module.exports = __webpack_public_path__ + "assets/images/slope-size/desktop.svg?v=dbf31934";